import React, { useContext, useState } from 'react'
import { IoAirplane, IoArrowBack, IoBoat, IoCar } from 'react-icons/io5';
import { FaTruck } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { boxes } from '../assets/mangoeaList'
import { CartContext } from '../Contexts/CartContext';

const ChooseBox = ({ goBack }) => {
    const { setBox, setTransport, transport } = useContext(CartContext);

    const [ boxId, setBoxId ] = useState(1);
    const [ list, setList ] = useState(boxes);

    const toggleBox = selectedBox => {
        setBox(selectedBox);
        setBoxId(selectedBox.id)
    }
    
    const toggleTransport = selectedTransport => {
        setTransport(selectedTransport);
    }

  return (
    <div className="ShoppingCart ChooseBox">
        <div className="head">
            <h2><IoArrowBack onClick={goBack} /> Une dernière étape</h2>
            {/* <div className="close" onClick={closeModal}>+</div> */}
        </div>

        <div className="choices">
            <h3>Choisissez un moyen de transport</h3>
            <div className="transport">
                <div
                    className={transport == "bateau" ? "box active" : "box"}
                    onClick={() => toggleTransport("bateau")}
                >
                    <span className="icon"><IoBoat /></span>Par bateau
                </div>

                <div
                    className={transport == "avion" ? "box active" : "box"}
                    onClick={() => toggleTransport("avion")}
                >
                    <span className="icon"><IoAirplane /></span> Par avion
                </div>

                <div
                    className={transport == "camion" ? "box active" : "box"}
                    onClick={() => toggleTransport("camion")}
                >
                    <span className="icon"><FaTruck /></span>Par camion
                </div>
            </div>
            
            <h3>Choisissez un type de cartom</h3>
            <div className="boxes">
                {
                    list.map((item) =>
                        <div
                            key={item.id}
                            className={boxId === item.id ? "box active" : "box"}
                            onClick={() => toggleBox(item)}
                        >
                            <div className="img">
                                <img src={item.img} alt="Carton" />
                            </div>
                            <div className="title">{item.nom}</div>
                        </div>    
                    )
                }
            </div>
        </div>
          
          <div className="totalbox">
            <div className="resume">
              {/* <div className="title">Sous total</div>
              <div className="amount">{total}</div> */}
            </div>
            <Link to="/checkout">Valider la commande</Link>
          </div>
    </div>
  )
}
 
export default ChooseBox